import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiRequest } from '../../config/api';

interface SensorOrder {
  _id: string;
  state: string;
  createdAt: string;
  user: {
    name: string;
    email: string;
    organization: string;
    userRole: string;
  } | null;
  aircraftid: {
    type: string;
    identification: string;
    withSensor: boolean;
  };
}

const StaffSensorOrders: React.FC = () => {
  const navigate = useNavigate();
  const [sensorOrders, setSensorOrders] = useState<SensorOrder[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchSensorOrders();
  }, []);

  const fetchSensorOrders = async () => {
    setLoading(true);
    setError('');
    try {
      const response = await apiRequest('/sensor-orders');

      if (!response.ok) {
        throw new Error('Failed to fetch sensor orders');
      }

      const data = await response.json();
      setSensorOrders(data);
    } catch (err: any) {
      setError(err.message);
      console.error('Error fetching sensor orders:', err);
    } finally {
      setLoading(false);
    }
  };


  return (
    <div className="row">
      <div className="col-12 mb-4">
        <div className="card shadow-sm" style={{ borderRadius: '12px' }}>
          <div className="card-body p-4">
            <h4 className="mb-4" style={{ fontWeight: 700, color: '#687088' }}>Sensorbestellungen</h4>

            {loading && <p style={{ color: '#687088' }}>Lade Bestellungen...</p>}
            {error && <div className="alert alert-danger">{error}</div>}

            {!loading && !error && sensorOrders.length === 0 && (
              <p style={{ color: '#687088' }}>Keine Bestellungen vorhanden.</p>
            )}

            {!loading && !error && sensorOrders.length > 0 && (
              <div className="table-responsive">
                <table className="table" style={{ color: '#687088' }}>
                  <thead>
                    <tr>
                      <th>Datum</th>
                      <th>Benutzer</th>
                      <th>Organisation</th>
                      <th>Rolle</th>
                      <th>Flugobjekt</th>
                      <th>Kennung</th>
                      <th>Status</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {sensorOrders.map((order) => (
                      <tr key={order._id}>
                        <td>{new Date(order.createdAt).toLocaleDateString('de-DE')}</td>
                        <td>{order.user?.name || 'N/A'}</td>
                        <td>{order.user?.organization || 'N/A'}</td>
                        <td>
                          {order.user?.userRole === 'pilot' ? 'Pilot' : 'Flugschule'}
                        </td>
                        <td>
                          {order.aircraftid.type === 'balloon' ? 'Ballon' :
                           order.aircraftid.type === 'glider' ? 'Segelflugzeug' :
                           order.aircraftid.type === 'plane' ? 'Motorflugzeug' : 'Hubschrauber'}
                        </td>
                        <td>{order.aircraftid.identification}</td>
                        <td>
                          <span className={`badge ${order.state === 'open' ? 'bg-warning' : 'bg-success'}`}>
                            {order.state === 'open' ? 'Offen' : 'Erledigt'}
                          </span>
                        </td>
                        <td>
                          <button
                            className="btn btn-sm btn-primary"
                            onClick={() => navigate(`/sensor-orders/${order._id}`)}
                          >
                            Details
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default StaffSensorOrders;
